import { newToolFilterOAuthMcp } from "../oauth.ts";

export const mondayMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://cdn.prod.website-files.com/656da6fea306219773d04208/65af6bd6e742d497b5f23f69_645898132bbaac20f1963919_256x256.png",
  url: "https://mcp.monday.com/mcp",
  label: "monday.com",
});
